const Comments = ({ partsRequest }: { partsRequest: string }) => (
  <div className="pt-6 px-4 flex flex-col gap-y-2">
    <h4 className="text-lg font-medium">Comments</h4>
    <p className="leading-5 text-sm prose whitespace-pre-wrap text-gray-900">{partsRequest}</p>
  </div>
)
export default Comments
